"use client";

import { useSyncExternalStore } from "react";

const SCROLL_THRESHOLD = 10;

let visible = true;
let lastScrollY = 0;
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((l) => l());
}

function onScroll() {
  const y = window.scrollY;
  const delta = y - lastScrollY;
  if (Math.abs(delta) < SCROLL_THRESHOLD) return;

  const next = y <= 0 || delta < 0;
  if (next !== visible) {
    visible = next;
    notify();
  }
  lastScrollY = y;
}

let listening = false;

function subscribe(callback: () => void) {
  listeners.add(callback);
  if (!listening) {
    window.addEventListener("scroll", onScroll, { passive: true });
    listening = true;
  }
  return () => {
    listeners.delete(callback);
    if (listeners.size === 0) {
      window.removeEventListener("scroll", onScroll);
      listening = false;
    }
  };
}

function getSnapshot() {
  return visible;
}

function getServerSnapshot() {
  return true;
}

export function useMobileNavVisible() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
